import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { BeachClubPage } from './pages/BeachClubPage';
import { SUPPage } from './pages/SUPPage';
import { SUPRacePage } from './pages/SUPRacePage';
import { SUPToursPage } from './pages/SUPToursPage';
import { SurfskiPage } from './pages/SurfskiPage';
import { WingFoilPage } from './pages/WingFoilPage';
import { WingFoilCampaignPage } from './pages/WingFoilCampaignPage';
import { EventsPage } from './pages/EventsPage';
import { WaterTribeFestPage } from './pages/WaterTribeFestPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { TranzilaSuccessPage } from './pages/TranzilaSuccessPage';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';
import { FloatingJoinButton } from './components/FloatingJoinButton';
import { WorkshopRegistrationPage } from './pages/WorkshopRegistrationPage';
import { AdditionalPaymentPage } from './pages/AdditionalPaymentPage';
import { AdditionalPaymentThankYouPage } from './pages/AdditionalPaymentThankYouPage';
import { ResetRetreatPage } from './pages/ResetRetreatPage';
import { WindMeterPage } from './pages/WindMeterPage';
import { WomensSUPMorningPage } from './pages/WomensSUPMorningPage';
import { SafeSpaceOnWaterPage } from './pages/SafeSpaceOnWaterPage';
import { CorporateTeamBuildingPage } from './pages/CorporateTeamBuildingPage';
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    // Only scroll to top if there's no hash (like #contact)
    if (!hash) {
      // Force immediate scroll
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // Also use window.scrollTo as backup
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    }
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <Router data-id="element-0" data-mp="st2i6gybyti7">
      <ScrollToTop data-id="element-1" data-mp="swqc3h7othxg" />
      <Routes data-id="element-2" data-mp="36hx792iaw2a">
        <Route path="/" element={<BeachClubPage data-id="element-4" data-mp="35gm54lhq9kk" />} data-id="element-3" data-mp="35yq6nee9s31" />
        <Route path="/sup" element={<SUPPage data-id="element-6" data-mp="3uct4vo20uv2l" />} data-id="element-5" data-mp="34nc9ur8j3y7" />
        <Route path="/sup-race" element={<SUPRacePage data-id="element-8" data-mp="3uc9km0owfule" />} data-id="element-7" data-mp="3udaxmaph6r5r" />
        <Route path="/sup-tours" element={<SUPToursPage data-id="element-10" data-mp="d57hf8hvkslp" />} data-id="element-9" data-mp="3uevui6z9im6s" />
        <Route path="/surfski" element={<SurfskiPage data-id="element-12" data-mp="d2l8p5j9071w" />} data-id="element-11" data-mp="d3cujon1mqez" />
        <Route path="/wingfoil" element={<WingFoilPage data-id="element-14" data-mp="86mgt7ypo6wq" />} data-id="element-13" data-mp="85ui3o9tht28" />
        <Route path="/wingfoil-campaign" element={<WingFoilCampaignPage data-id="element-16" data-mp="3gl4rlhg1e0k1" />} data-id="element-15" data-mp="86cmj86mvdl8" />
        <Route path="/events" element={<EventsPage data-id="element-18" data-mp="3gja6o34rm8fy" />} data-id="element-17" data-mp="3gm63tp8sgt3c" />
        <Route path="/water-tribe-fest" element={<WaterTribeFestPage data-id="element-20" data-mp="3bnmgpliglb9e" />} data-id="element-19" data-mp="3bmjrdi0sbgvl" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-22" data-mp="3qbpo8zc5gv0b" />} data-id="element-21" data-mp="3bk720jsp648i" />
        <Route path="/tranzila-success" element={<TranzilaSuccessPage data-id="element-24" data-mp="3qd0rmy1oo0qw" />} data-id="element-23" data-mp="3qc93u9ebv7b6" />
        <Route path="/admin/login" element={<AdminLogin data-id="element-26" data-mp="3liwkadoi9qpa" />} data-id="element-25" data-mp="3ljxukfxp695y" />
        <Route path="/admin" element={<AdminDashboard data-id="element-28" data-mp="2xun01g6xxb09" />} data-id="element-27" data-mp="3liehszb92g8x" />
        <Route path="/workshop-registration" element={<WorkshopRegistrationPage data-id="element-30" data-mp="2xsk3edba8jmk" />} data-id="element-29" data-mp="2xtlqxh9hiyl6" />
        <Route path="/additional-payment" element={<AdditionalPaymentPage data-id="element-32" data-mp="2stpm5fsyr34k" />} data-id="element-31" data-mp="2swljb1wzlnry" />
        <Route path="/additional-payment-thank-you" element={<AdditionalPaymentThankYouPage data-id="element-34" data-mp="18cgf7v0805m6" />} data-id="element-33" data-mp="18e17fdz2bcgv" />
        <Route path="/reset-retreat" element={<ResetRetreatPage data-id="element-36" data-mp="1d59j6gnv79x7" />} data-id="element-35" data-mp="1d47yrlkylb2t" />
        <Route path="/wind-meter" element={<WindMeterPage data-id="element-38" data-mp="yg3n31kbpztj" />} data-id="element-37" data-mp="1d6kkm9tu85l5" />
        <Route path="/womens-sup-morning" element={<WomensSUPMorningPage data-id="element-40" data-mp="ydqwk00i2h4v" />} data-id="element-39" data-mp="ygwkhbxe7cz0" />
        <Route path="/safe-space-on-water" element={<SafeSpaceOnWaterPage data-id="element-42" data-mp="13ey3jwutjcah" />} data-id="element-41" data-mp="13dwt9ulmmttt" />
        <Route path="/team-building" element={<CorporateTeamBuildingPage data-id="element-44" data-mp="1r5kd5skh14ml" />} data-id="element-43" data-mp="1r4ipmom9qpnz" />
      </Routes>
      <ConditionalFloatingButton data-id="element-45" data-mp="1w3c68pwuqwsd" />
    </Router>;
}
function ConditionalFloatingButton() {
  const location = useLocation();
  // Don't show the general floating button on Water Tribe Fest page, Thank You page, or Tranzila Success page
  if (location.pathname === '/water-tribe-fest' || location.pathname === '/thank-you' || location.pathname === '/tranzila-success' || location.pathname === '/additional-payment' || location.pathname === '/additional-payment-thank-you' || location.pathname === '/reset-retreat' || location.pathname === '/womens-sup-morning' || location.pathname === '/safe-space-on-water' || location.pathname === '/team-building' || location.pathname === '/wingfoil-campaign') {
    return null;
  }
  if (location.pathname === '/events') {
    return <FloatingJoinButton label="השאירו פרטים" data-id="element-46" data-mp="h7lvin7bckcz" />;
  }
  return <FloatingJoinButton data-id="element-47" data-mp="c90voovz42p2" />;
}